const state = () => {
  return {
    sc_measure_units: [],
    sc_measure_unit: {},
    sc_measure_unit_filters: {},
  }
}

export default state;
